export default "__VITE_ASSET__7127638d__"